import { render, staticRenderFns } from "./sqlc.vue?vue&type=template&id=fd1471b2&scoped=true"
import script from "./sqlc.vue?vue&type=script&lang=js"
export * from "./sqlc.vue?vue&type=script&lang=js"
import style0 from "./sqlc.vue?vue&type=style&index=0&id=fd1471b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1471b2",
  null
  
)

export default component.exports